import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  data: null,
  eventList: [],
};

// Slice
const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    getEvents() {},
    setEvents(state, action) {
      const { eventList } = action.payload;
      return {
        ...state,
        eventList,
      };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const { getEvents, setEvents, fetchDataSuccess, fetchDataFailure } =
  eventsSlice.actions;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, data = {} } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.get, apiUrl);

    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const { code, data } = response.data;
      if (code === "0000") {
        yield put(setEvents({ eventList: data }));
      }
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* eventsSaga() {
  yield takeLatest(getEvents.type, fetchDataSaga);
}

export default eventsSlice.reducer;
